import React from 'react';
import {
    makeStyles,
    Grid,
    Typography,
    Button,
    Dialog,
    DialogContent,
} from '@material-ui/core';


const MassDeleteUsersDialog = (props) => {

    const useStyles = makeStyles((theme) => ({
        createUserButton: {
            width: 165,
            fontSize: 16,
            fontWeight: 600,
            backgroundColor: '#af001e',
            color: 'white',
            borderRadius: 0,
            '&:hover': {
                backgroundColor: '#af001eA5',
            }
        },
        dialogZ: {
            zIndex: 3000
        }
    }));

    const classes = useStyles();
    const {
        massDeleteDialog,
        handleToggleMassDeleteDialog,
        deleteSelectedUsers
    } = props;

    return (
        <Dialog
            PaperProps={{
                style: {
                    borderRadius: 0,
                    padding: 20
                }
            }}
            maxWidth="xs"
            open={massDeleteDialog}
            disableBackdropClick
            onClose={handleToggleMassDeleteDialog}
            keepMounted>
            <DialogContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Typography style={{ color: '#3e3f60', fontSize: 30, fontWeight: 600 }}>Delete User?</Typography>
                    </Grid>
                    <Grid item>
                        <Typography style={{ color: '#3e3f60', fontSize: 18 }}>
                            Are you sure you want to delete selected users? This action will not be reversible.
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" alignItems="flex-start">
                            <Grid item>
                                <Button fullWidth size="large" className={classes.createUserButton} onClick={() => deleteSelectedUsers()} color="primary">
                                    Yes, delete
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button fullWidth style={{ color: '#3e3f60', fontSize: 16, fontWeight: 600, width: 168 }} size="large" onClick={() => handleToggleMassDeleteDialog()} color="primary">
                                    No, cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default MassDeleteUsersDialog;
